import React, {useState, useEffect, useRef} from 'react'
import thryvPeek from '../assets/thryv-peek-2.png'
import {client} from '../utils/api-client'
import {
  getSwitchableCountries,
  isSwitchableCountry,
  isUsdOnlyCountry,
} from '../utils/country-registry'
import {Button} from '@thryvlabs/maverick'
import {AppSpinner, SummarySpinner} from '../components/custom/loader-spinner'
import {
  KCPPaymentDetails,
  computeTabTotal,
  getCoreTabItemCount,
} from '../components/subscription-summary'
import {AccountDetails} from '../components/account-details'
import {formatSubDetails} from '../utils/util'
import {
  applyOwnedSubscriptionPrices,
  attachLocationCoupons,
  buildCorePaymentCart,
  fetchLocationNames,
  fetchOwnedSubscriptionsByLocation,
  getCorePaymentPlanCodes,
} from '../utils/core-payment-cart'
import {formatPrice} from '../utils/currency-format'
import {
  isInternationalTaxIdCountry,
  normalizeTaxIdentifier,
} from '../utils/country-registry'
import {GradientTabs, GradientTab} from '../core/shared/GradientTabs'
import {useNavigate, useLocation} from 'react-router-dom'
import {toast} from 'react-toastify'
import {useAsync} from '../utils/use-async'
// import rawCountryStates from 'iso3166-2-db/i18n/en'
// import validator from 'validator'
import {PhoneNumberUtil} from 'google-libphonenumber'
import * as yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm} from 'react-hook-form'
import keapLogo from '../assets/keap_brand_logo.svg'
import logo from '../assets/thryv-logo-white-letters.svg'
import '../styles/formScreensStyles.css'
import ExpiryCountdownTimer from '../components/expiry-countdown-timer'
import {useSelector} from 'react-redux'
import {
  appointmentRequiredCodes,
  INFLUENCER_MARKETING_CENTER_CODES,
  isKeapPlanCode,
  SIGNATURE_CODES,
  SEO_CODES,
} from '../utils/addons-data'
import {
  isInfluencerLink,
  usesInfluencerScheduling,
} from '../utils/partner-scheduling'
import {
  fetchSelectedCountryRegionList,
  validatePostalCode,
} from '../utils/address-validation'

function HeaderDivider() {
  return (
    <div
      className="header-divider"
      style={{
        height: '36px',
        marginInline: '16px',
        flexShrink: 0,
        border: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    />
  )
}

export function ThryvAndKeapHeader({
  businessName,
  totalAmount,
  linkExpiryInMilliSec,
}) {
  return (
    <header
      className="header-container"
      style={{
        paddingLeft: '32px',
        paddingRight: '24px',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          paddingBlock: '24px',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginRight: '22px',
          gap: '12px',
          minWidth: 0,
        }}
      >
        <div
          style={{
            display: 'flex',
            marginRight: '120px',
            alignItems: 'center',
            gap: 0,
            flexShrink: 0,
          }}
        >
          <img src={logo} alt="Thryv Logo" className="header-logo" />
          <HeaderDivider />
          <img
            src={keapLogo}
            alt="Keap Logo"
            className="header-logo"
            style={{filter: 'brightness(0) invert(1)'}}
          />
        </div>
        {businessName && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexShrink: 0,
              justifyContent: 'center',
            }}
          >
            <span className="payment-header-label">You&apos;re paying for</span>
            <span
              className="payment-header-value"
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {businessName}
            </span>
          </div>
        )}
        {linkExpiryInMilliSec > 0 && (
          <>
            <HeaderDivider />
            <ExpiryCountdownTimer
              countdownTimeMS={linkExpiryInMilliSec}
              isHourlyNeeded={linkExpiryInMilliSec > 60 * 60 * 1000}
            />
          </>
        )}
        <div
          className="header-order-summary"
          style={{
            marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            flexShrink: 1,
            minWidth: 0,
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              minWidth: 0,
            }}
          >
            <span
              style={{fontSize: '18px', lineHeight: '100%'}}
              className="payment-header-value"
            >
              Order Summary
            </span>
            <span className="payment-header-note" style={{maxWidth: '220px'}}>
              Future invoices will include any eligible discount for as long as
              your account qualifies.
            </span>
          </div>
        </div>
      </div>
      {totalAmount && (
        <div className="payment-total-container">
          <p className="payment-total-label">Total</p>
          <p className="payment-total-amount">
            {totalAmount?.replace(' + Tax', '')}
            {totalAmount?.includes('+ Tax') && (
              <span className="payment-total-label"> + Tax</span>
            )}
          </p>
        </div>
      )}
    </header>
  )
}

export function OrderDetailsComponent() {
  const [activeRightTab, setActiveRightTab] = useState('today')
  const [emailRegistered, setEmailRegistered] = useState(true)
  const [listOfStates, setListOfStates] = useState([])
  const [validatedEmail, setValidatedEmail] = useState('')
  const [existingThryvId, setExistingThryvId] = useState(null)
  const [, setAccountInformation] = useState({})
  const [cartDetailObj, setCartDetailObj] = useState({})
  // {[locationThryvId]: business name} for a multi-location link's headers.
  const [locationNames, setLocationNames] = useState({})
  const [subscriptionList, setSubscriptionList] = useState({})
  const [couponList, setCouponList] = useState([])
  const [partnerLinkData, setPartnerLinkData] = useState({})
  const [influencerAccountInfo, setInfluencerAccountInfo] = useState(null)
  const hasAutoAdvancedRef = useRef(false)
  const [isFormFilled, setFormFilledStatus] = useState(true)
  const [isLoadingCompleted, setLoadCompletionStatus] = useState(true)
  const [selectedCountry, setSelectedCountry] = useState('US')
  const [currency, setCurrency] = useState('USD')
  const [showComingSoonModal, setShowComingSoonModal] = useState(false)
  const [linkDefaultCountry, setLinkDefaultCountry] = useState('US')
  const isGB = selectedCountry === 'GB'
  const localizedAddressCountry = isUsdOnlyCountry(selectedCountry)
  const stateLabel = isGB
    ? 'County'
    : localizedAddressCountry
      ? 'Region / State / Province'
      : 'State'
  const postalLabel = localizedAddressCountry
    ? 'Postal / Zip Code'
    : 'Postal Code'
  const cityLabel = isGB ? 'City/Town' : 'City'
  const navigate = useNavigate()
  const navData = useLocation()
  // Only influencer 1:1 links reach this screen with linkType '1:1' (partner 1:1
  // goes straight to /client-payment after OTP). Derive this from nav state so it
  // is known immediately — before partnerLinkData loads — to avoid flashing the
  // 1:many account form on the first render. This branch renders nothing and
  // auto-advances straight to scheduling/payment.
  const isInfluencerOneToOne = navData?.state?.linkType === '1:1'
  const {run} = useAsync({
    status: 'pending',
  })
  console.log({subscriptionList, isLoadingCompleted})
  const phoneUtil = PhoneNumberUtil.getInstance()
  const REQUIRED_FIELD_MESSAGE = 'This field is required'
  const REQUIRED_OPTION_MESSAGE = 'Please select an option'
  const MIN_CHARACTERS_REQUIRED = 'Must be at least 3 characters'
  const MAX_CHARACTERS_REQUIRED = 'Must be at most 120 characters'
  const VALID_EMAIL_MESSAGE = 'Must be a valid email'
  const VALID_WEBSITE_URL_MESSAGE = 'Please enter a valid url'

  // const getStateLabel = countryCode => {
  //   if (['US', 'AU', 'NZ'].includes(countryCode)) {
  //     return 'State'
  //   } else if (countryCode === 'KY') {
  //     return 'City'
  //   } else if (countryCode === 'CA') {
  //     return 'Province'
  //   } else if (countryCode === 'BB') {
  //     return 'Parish'
  //   }
  //   return 'State'
  // }

  const getCurrencyForCountry = countryCode => {
    if (countryCode === 'CA') return 'CAD'
    if (countryCode === 'AU') return 'AUD'
    if (countryCode === 'NZ') return 'NZD'
    if (countryCode === 'GB') return 'GBP'
    return 'USD'
  }

  const SUPPORTED_COUNTRIES = getSwitchableCountries()

  const getIncompatibleItems = (currencyCode, linkItems, catalogSubList) => {
    const allCatalogPlans = [
      ...(catalogSubList.centers || []),
      ...(catalogSubList.apps || []),
      ...(catalogSubList.oneTimeFees || []),
    ]
    const SKIP_CURRENCY_CHECK = [
      'addon-5-signature_usage',
      'app-websitebuilder',
    ]
    return (linkItems || []).filter(({code}) => {
      if (SKIP_CURRENCY_CHECK.includes(code)) return false
      const catalogPlan = allCatalogPlans.find(p => p.code === code)
      if (!catalogPlan) return false
      const currencies = catalogPlan.currencies || []
      if (currencies.length === 0) return false
      return !currencies.some(c => c.currency === currencyCode)
    })
  }

  const handleCountryChange = async newCountry => {
    const newCurrency = getCurrencyForCountry(newCountry)
    const newCurrencyForProductValidation =
      newCountry === 'CA'
        ? 'CAD'
        : newCountry === 'AU'
          ? 'AUD'
          : newCountry === 'NZ'
            ? 'NZD'
            : newCountry === 'GB'
              ? 'GBP'
              : newCountry === 'US'
                ? 'USD'
                : 'OTH'

    const allLinkItems = [
      ...(partnerLinkData.plan_code?.plan || []),
      ...(partnerLinkData.add_on_code?.addon || []),
      ...(partnerLinkData.add_on_code?.addon || []).flatMap(
        a => a.addons || [],
      ),
    ]

    const incompatiblePlans = getIncompatibleItems(
      newCurrencyForProductValidation,
      allLinkItems,
      subscriptionList,
    )
    console.log(
      '[handleCountryChange] incompatible plans/addons:',
      incompatiblePlans.map(i => i.code),
    )

    if (incompatiblePlans.length > 0) {
      setShowComingSoonModal(true)
      return
    }

    const catalogList = [
      ...(subscriptionList?.centers || []),
      ...(subscriptionList?.apps || []),
      ...(subscriptionList?.oneTimeFees || []),
    ]
    const oneTimeFees = (partnerLinkData?.add_on_code?.oneTimeFees || []).map(
      fee => {
        const catalogFee = catalogList.find(f => f.code === fee.code)
        if (catalogFee) {
          const currencyEntry = (catalogFee.currencies || []).find(
            c => c.currency === newCurrency,
          )
          return {
            ...fee,
            unitAmount: currencyEntry?.unitAmount ?? fee.unitAmount,
          }
        }
        return fee
      },
    )
    const subJSON = {
      plan: (partnerLinkData.plan_code?.plan || []).map(p => ({
        ...p,
        unitAmount: undefined,
      })),
      addons: (partnerLinkData.add_on_code?.addon || []).map(a => ({
        ...a,
        unitAmount: undefined,
      })),
      oneTimeFees,
    }
    const cartObj = formatSubDetails(subJSON, subscriptionList, newCurrency)
    const updatedCoupons = await getCouponDetails(
      partnerLinkData,
      cartObj?.plans,
      newCountry,
    )

    if (updatedCoupons.some(c => c.isCurrencyAvailable === false)) {
      setShowComingSoonModal(true)
      return
    }

    setSelectedCountry(newCountry)
    setCurrency(newCurrency)
    setCouponList(updatedCoupons)
    setCartDetailObj(cartObj)
  }

  // Postal code regex - fixed patterns for specific countries
  const BB_POSTAL_REGEX = /^[A-Za-z]{2}\d{5}$/ // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
  const KY_POSTAL_REGEX = /^[A-Za-z]{2}\d-?\d{4}$/ // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
  const CA_POSTAL_REGEX = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/ // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos

  const validateZipCode = (value, countryCode) => {
    if (!value) {
      return false
    }
    if (countryCode === 'BB') {
      return BB_POSTAL_REGEX.test(value) // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
    }
    if (countryCode === 'KY') {
      return KY_POSTAL_REGEX.test(value) // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
    }
    if (countryCode === 'CA') {
      return CA_POSTAL_REGEX.test(value) // nosemgrep: nodejs_scan.javascript-dos-rule-regex_dos
    }
    return validatePostalCode(countryCode, value)
  }

  const SCHEMA = yup.object().shape({
    firstName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    lastName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    email: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .email(VALID_EMAIL_MESSAGE),
    company: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    postCode: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-postCode-format',
        'Incorrect post code format',
        function (value) {
          // return validatePostalCode(value, selectedCountry)
          if (!value) {
            return false
          }
          let postalValidationStatus = validateZipCode(value, selectedCountry)
          return postalValidationStatus
        },
      ),
    websiteName: yup
      .string()
      // .url(VALID_WEBSITE_URL_MESSAGE)
      .matches(
        /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
        VALID_WEBSITE_URL_MESSAGE,
      )
      .required(REQUIRED_FIELD_MESSAGE),
    address: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    city: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    state: yup.object().shape({
      name: yup.string().required(REQUIRED_OPTION_MESSAGE),
      value: yup.string().required(REQUIRED_OPTION_MESSAGE),
    }),
    mobile: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
    companyPhone: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
    abn: yup.string().test('validate-abn', function (value) {
      if (selectedCountry === 'AU') {
        const cleaned = value ? value.replaceAll(' ', '') : ''
        if (!cleaned || cleaned.length !== 11) {
          return this.createError({
            message: 'Please enter a valid, 11-digit ABN',
          })
        }
        if (!/^\d+$/.test(cleaned)) {
          return this.createError({
            message: 'Please enter a valid, 11-digit ABN',
          })
        }
      }
      if (selectedCountry === 'NZ') {
        if (!value) return true
        const cleaned = value.replaceAll(' ', '')
        if (cleaned.length !== 13) {
          return this.createError({
            message: 'Please enter a valid, 13-digit NZBN',
          })
        }
        if (!/^\d+$/.test(cleaned)) {
          return this.createError({
            message: 'Please enter a valid, 13-digit NZBN',
          })
        }
      }
      return true
    }),
  })

  const DEFAULT_VALUES = {
    email: '',
    prospectEmail: '',
    prospectFirstName: '',
    prospectLastName: '',
  }
  const {
    register,
    formState: {errors},
    control,
    handleSubmit,
    watch,
    trigger,
    reset,
    getValues,
    setValue,
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(SCHEMA),
  })

  const [email, state] = watch(['email', 'state'])

  React.useEffect(() => {
    // const states = rawCountryStates[selectedCountry].regions
    //   .map(({iso, name}) => ({
    //     name,
    //     value: iso || name,
    //   }))
    //   .sort((a, b) => (a.name > b.name ? 1 : -1))
    // setListOfStates(states)
    let data = fetchSelectedCountryRegionList(selectedCountry)
    // console.log(data)
    setListOfStates(data)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry])

  useEffect(() => {
    const validationError = navData.state?.accountValidationError
    const ai = navData.state?.accountInformation
    if (!validationError || !ai || !listOfStates.length) return
    const stateOption = listOfStates.find(s => s.value === ai.state) || null
    reset({
      email: ai.email || '',
      firstName: ai.firstName || '',
      lastName: ai.lastName || '',
      company: ai.company || '',
      address: ai.address || '',
      city: ai.city || '',
      state: stateOption,
      postCode: ai.postCode || '',
      mobile: ai.mobile || '',
      companyPhone: ai.companyPhone || '',
      websiteName: ai.websiteName || '',
      abn: ai.abn || getValues('abn') || '',
    })
    // Show the server's actual reason (e.g. address not confirmed, email already
    // registered, provider outage) instead of always blaming the address.
    toast.error(
      `${validationError} Please contact your Keap partner representative to correct the details and send a new link.`,
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listOfStates])

  useEffect(() => {
    if (!existingThryvId || !listOfStates.length) return
    const populateFromExistingAccount = async () => {
      try {
        const accData = await client(
          `orders/validate-emailaccount/${existingThryvId}`,
        )
        if (!accData) return
        const stateOption =
          listOfStates.find(s => s.value === accData.state) || null
        reset({
          email: accData.email || '',
          firstName: accData.firstName || '',
          lastName: accData.lastName || '',
          company: accData.company || '',
          address: accData.address || '',
          city: accData.city || '',
          state: stateOption,
          postCode: accData.postCode || '',
          mobile: '',
          companyPhone: accData.phone || '',
          websiteName: '',
          abn: accData.abn || getValues('abn') || '',
        })
      } catch (err) {
        console.log(err)
      }
    }
    populateFromExistingAccount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [existingThryvId, listOfStates])

  const fetchInfluencerAccountInfo = async () => {
    const custThryvId = navData?.state?.custThryvId
    try {
      const acc = await client(`orders/validate-emailaccount/${custThryvId}`)
      return {
        firstName: acc?.firstName || '',
        lastName: acc?.lastName || '',
        email: acc?.email || navData.state.custEmail || '',
        company: acc?.company || '',
        address: acc?.address || '',
        city: acc?.city || '',
        state: acc?.state || '',
        postCode: acc?.postCode || '',
        mobile: acc?.phone || '',
        companyPhone: acc?.phone || '',
        country: acc?.country || selectedCountry,
        thryvId: acc?.thryvID || custThryvId,
      }
    } catch (err) {
      return {
        email: navData.state.custEmail || '',
        thryvId: custThryvId,
      }
    }
  }

  useEffect(() => {
    if (!isInfluencerOneToOne || !navData?.state?.custThryvId) {
      return
    }
    fetchInfluencerAccountInfo().then(info => {
      setInfluencerAccountInfo(info)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInfluencerOneToOne, navData?.state?.custThryvId])

  useEffect(() => {
    console.log({navData, id: navData.state?.id})
    if (!navData || !navData?.state || !navData.state?.id) {
      toast.error('Please contact admin for support')
    }
    const getOrderDetail = async () => {
      try {
        const id = navData?.state?.id || 25
        setLoadCompletionStatus(false)
        let data = await client(`cc/order/keapClient/fetchOrder?id=${id}`)
        let subList = await client(`plans/5/v1/list`)
        setSubscriptionList(subList)
        setPartnerLinkData(data)
        console.log('data: order-details:247', data)
        console.log('subList: order-details:248', subList)

        // Set country and currency from keap_partner_links
        const countryCode = data?.country_code || 'US'
        setSelectedCountry(countryCode)
        setLinkDefaultCountry(countryCode)
        const currencyCode = getCurrencyForCountry(countryCode)
        setCurrency(currencyCode)
        const newCurrencyForProductValidation =
          countryCode === 'CA'
            ? 'CAD'
            : countryCode === 'AU'
              ? 'AUD'
              : countryCode === 'NZ'
                ? 'NZD'
                : countryCode === 'GB'
                  ? 'GBP'
                  : countryCode === 'US'
                    ? 'USD'
                    : 'OTH'

        // Check if all plans in the link have a price for this currency
        if (
          getIncompatibleItems(
            newCurrencyForProductValidation,
            data.plan_code?.plan,
            subList,
          ).length > 0
        ) {
          setShowComingSoonModal(true)
          setLoadCompletionStatus(true)
          return
        }

        // Account Setup wizard links persist the Core send-link payload. Build
        // the cart and coupons the same way the payment screen does, so this
        // summary (and the scheduler that reuses it) matches the payment page.
        const corePaymentPayload = data?.plan_code?.corePaymentPayload
        if (corePaymentPayload) {
          // Owned lines show what the account really pays (same as the core OOE
          // payment link); a failed lookup just keeps their catalog price.
          const coreCart = buildCorePaymentCart(
            applyOwnedSubscriptionPrices(
              corePaymentPayload,
              await fetchOwnedSubscriptionsByLocation(
                client,
                corePaymentPayload,
              ),
            ),
            subList,
            getCurrencyForCountry(countryCode),
          )
          const planCodes = getCorePaymentPlanCodes(coreCart)
          // Validated in parallel (order preserved) — each is its own round trip.
          const coreCoupons = (
            await Promise.all(
              [...new Set(corePaymentPayload.coupons || [])].map(async code => {
                try {
                  return await client(
                    `orders/coupon/validate?couponCode=${code}&country=${countryCode}&planCode=${planCodes.join()}`,
                  )
                } catch (err) {
                  console.log('Error validating coupon', code, err)
                  return null
                }
              }),
            )
          ).filter(couponDetails => couponDetails?.isValid)
          setCouponList(coreCoupons)
          // Display-only: a failed lookup falls back to the thryvId.
          fetchLocationNames(client, corePaymentPayload).then(setLocationNames)
          // Same as the payment screen: each location shows its own coupons.
          setCartDetailObj(
            attachLocationCoupons(coreCart, corePaymentPayload, coreCoupons),
          )
          setLoadCompletionStatus(true)
          return
        }

        let oneTimeFees = []
        if (data?.add_on_code?.oneTimeFees) {
          oneTimeFees = data?.add_on_code?.oneTimeFees
        }
        const subJSON = {
          plan: [...data.plan_code.plan],
          addons: [...data.add_on_code.addon],
          oneTimeFees,
        }
        let cartObj = formatSubDetails(
          subJSON,
          subList,
          getCurrencyForCountry(countryCode),
        )
        const initialCoupons = await getCouponDetails(
          data,
          cartObj?.plans,
          countryCode,
        )
        setCouponList(initialCoupons)
        setCartDetailObj(cartObj)
        setLoadCompletionStatus(true)
      } catch (err) {
        console.log('errror', err)
        // Never leave the summary spinner running if the order could not load.
        setLoadCompletionStatus(true)
      }
    }

    getOrderDetail()
  }, [])

  const getCouponDetails = async (data, planList = [], country = 'US') => {
    try {
      console.log({data, planList, country})
      const codes = []
      if (data?.plan_code && data?.plan_code.plan.length > 0) {
        for (const plan of data.plan_code.plan) {
          if (!plan.code.startsWith('cc')) {
            codes.push(plan.code)
          }
        }
      }

      if (
        data?.add_on_code &&
        data?.add_on_code?.addon &&
        data?.add_on_code.addon.length > 0
      ) {
        for (const item of data.add_on_code.addon) {
          codes.push(item.code)
        }
      }

      let incentiveCodes =
        data?.default_incentive?.defaultIncentives.toString() || ''
      incentiveCodes = incentiveCodes.split(',')

      let couponDetails

      let couponArray = []
      if (incentiveCodes.length > 0) {
        for (let incentiveCode of incentiveCodes) {
          if (incentiveCode.length > 0) {
            let incentiveDetail = await run(
              client(
                `orders/coupon/validate?couponCode=${incentiveCode}&country=${country}&planCode=${codes.join()}`,
              ),
            )
            // incentiveDetails.push(incentiveDetail)
            if (incentiveDetail && incentiveDetail?.isValid) {
              couponArray.push(incentiveDetail)
            }
          }
        }
      }
      if (
        data?.coupon_code?.couponCodes &&
        data.coupon_code.couponCodes.length > 0
      ) {
        for (const coupon of data.coupon_code.couponCodes) {
          couponDetails = await run(
            client(
              `orders/coupon/validate?couponCode=${coupon}&country=${country}&planCode=${codes.join()}`,
            ),
          )
          if (couponDetails && couponDetails?.isValid) {
            couponArray.push(couponDetails)
          }
        }
      }

      // if (incentiveDetails && incentiveDetails?.isValid) {
      //   couponArray.push(incentiveDetails)
      // }
      return couponArray
    } catch (err) {
      console.log(err)
      return []
    }
  }

  const routeAfterOrderDetails = ({accountInformation, id}) => {
    // Influencer and Partner 1:Many links book onboarding the same way
    const hasInfluencer = usesInfluencerScheduling(
      partnerLinkData,
      navData?.state?.linkType,
    )
    // Signature requires appointment only when includeOnboarding is explicitly 'yes'
    console.log('partnerLinkData :: ', JSON.stringify(partnerLinkData))
    const hasSignatureWithOnboarding = partnerLinkData?.plan_code?.plan?.some(
      plan =>
        SIGNATURE_CODES.includes(plan.code) &&
        (plan?.customFields?.includeOnboarding?.value?.toLowerCase() ===
          'yes' ||
          String(plan?.customFields?.includeOnboarding || '').toLowerCase() ===
            'yes' ||
          String(plan?.includeOnboarding || '').toLowerCase() === 'yes'),
    )

    // Keap plans need a call only on Influencer links — Keap Partners onboard
    // their own Keap customers.
    const keapPlanNeedsCall = isInfluencerLink(partnerLinkData)

    // Signature Plus and SEO are covered by appointmentRequiredCodes; Signature is conditional above
    const hasAppointmentRequiredProduct =
      hasSignatureWithOnboarding ||
      (cartDetailObj?.plans?.some(
        plan =>
          appointmentRequiredCodes.includes(plan.code) ||
          (keapPlanNeedsCall &&
            (isKeapPlanCode(plan.code) ||
              INFLUENCER_MARKETING_CENTER_CODES.includes(plan.code))),
      ) ??
        false)

    const seoAddon = partnerLinkData?.plan_code?.plan?.find(plan =>
      SEO_CODES.includes(plan.code),
    )
    const seoProposalId = seoAddon?.customFields?.alphaProposalId || null
    localStorage.setItem(
      'orderDetail',
      JSON.stringify({orderDetail: cartDetailObj}),
    )
    const routeState = {
      orderDetail: cartDetailObj,
      accountInformation,
      linkId: id,
      id,
      couponList,
      locationNames,
      keapPartnerLinkDetail: partnerLinkData,
      linkType: navData?.state?.linkType,
      country: selectedCountry,
      custEmail: accountInformation?.email,
      custThryvId: navData?.state?.custThryvId,
      seoProposalId,
      existingThryvId,
    }
    // Influencer links (1:1 and 1:Many) never schedule in ooe-app — the client
    // books onboarding here, after account details and before payment.
    if (hasInfluencer && hasAppointmentRequiredProduct) {
      navigate('/client-appointment', {state: routeState})
    } else {
      sessionStorage.removeItem('scheduleKickOffCallDetails')
      sessionStorage.removeItem('scheduleCreativeCallDetails')
      navigate('/client-payment', {state: routeState})
    }
  }

  const handleInfluencer11Continue = async () => {
    const id = navData?.state?.id
    let info = influencerAccountInfo
    if (!info || !info.firstName) {
      info = await fetchInfluencerAccountInfo()
      setInfluencerAccountInfo(info)
    }
    const accountInformation = {
      ...(info || {email: navData?.state?.custEmail || ''}),
    }
    routeAfterOrderDetails({accountInformation, id})
  }

  useEffect(() => {
    if (
      isInfluencerOneToOne &&
      isLoadingCompleted &&
      partnerLinkData?.plan_code &&
      !hasAutoAdvancedRef.current
    ) {
      hasAutoAdvancedRef.current = true
      handleInfluencer11Continue()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInfluencerOneToOne, isLoadingCompleted, partnerLinkData?.plan_code])

  const handleOrderDetailContinue = async formData => {
    try {
      const accountInformation = setData(formData)
      await client('accounts/address/validate', {
        data: {
          city: formData.city,
          state: formData.state.value,
          zipCode: formData.postCode,
          country: selectedCountry,
        },
      })
      const id = navData?.state?.id || 25
      let data = {
        linkId: id,
        currentScreen: 'accountInfo',
        baseUrl: window.location.href,
      }
      await run(
        client('keappartner/updatePartnerActivity', {data, method: 'PUT'}),
      )

      setLoadCompletionStatus(true)
      routeAfterOrderDetails({accountInformation, id})
    } catch (err) {
      if (err?.message) {
        toast.error(err.message)
      } else {
        console.log(err)
      }
      setLoadCompletionStatus(true)
    }
  }

  const setData = formData => {
    console.log('formData in setData is ' + JSON.stringify(formData))
    const trim = v => (typeof v === 'string' ? v.trim() : (v ?? ''))
    let data = {
      ...formData,
      firstName: trim(formData.firstName),
      lastName: trim(formData.lastName),
      company: trim(formData.company),
      address: trim(formData.address),
      city: trim(formData.city),
      country: selectedCountry,
      state: formData.state.value,
      postCode: trim(formData.postCode),
      businessAddress: {
        city: trim(formData.city),
        state: formData.state.value,
        country: selectedCountry,
        phone: formData.companyPhone,
        street: trim(formData.address),
        postalCode: trim(formData.postCode),
      },
      contactPhone: formData.mobile,
      currency: currency,
      flow: 'new',
      mcDomain: formData.websiteName,
    }
    if (
      (['AU', 'NZ'].includes(selectedCountry) ||
        isInternationalTaxIdCountry(selectedCountry)) &&
      formData.abn
    ) {
      data.abn = normalizeTaxIdentifier(selectedCountry, formData.abn)
    }
    return data
  }

  const {isMobileViewEnable} = useSelector(state => state.screenView)

  useEffect(() => {
    if (!isMobileViewEnable) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [isMobileViewEnable])

  return (
    <>
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          background: 'linear-gradient(to bottom, #171d37, #6474a9)',
          zIndex: -1,
        }}
      />
      <ThryvAndKeapHeader
        totalAmount={(() => {
          const t = computeTabTotal({
            paymentDetailType: 'today',
            cartDetailObj,
            couponList,
            country: selectedCountry,
          })
          return t != null
            ? `${formatPrice({amount: t, country: selectedCountry})} + Tax`
            : undefined
        })()}
      />
      {isInfluencerOneToOne ? (
        <AppSpinner />
      ) : isMobileViewEnable ? (
        <section
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '80%',
            margin: '0% 10%',
            gap: '24px',
          }}
        >
          <section style={{display: 'flex', flexDirection: 'column'}}>
            <p
              style={{
                paddingTop: '20px',
                fontWeight: 700,
                fontFamily: 'Open Sans',
                fontSize: '20px',
                color: 'white',
              }}
            >
              Account Information
            </p>
            <div
              style={{
                backgroundColor: 'white',
                border: '1px solid #ECEEF1',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0px 2px 4px 0px #00000040',
                paddingInline: '43px',
                paddingTop: '32px',
                paddingBottom: '24px',
                width: '100%',
              }}
            >
              <AccountDetails
                register={register}
                errors={errors}
                listOfStates={listOfStates}
                validatedEmail={validatedEmail}
                setValidatedEmail={setValidatedEmail}
                email={email}
                emailRegistered={emailRegistered}
                setEmailRegistered={setEmailRegistered}
                setAccountInformation={setAccountInformation}
                setFormFilledStatus={setFormFilledStatus}
                trigger={trigger}
                control={control}
                setValue={setValue}
                state={state}
                handleSubmit={handleSubmit}
                selectedCountry={selectedCountry}
                onSessionResume={setExistingThryvId}
                stateLabel={stateLabel}
                cityLabel={cityLabel}
                postalLabel={postalLabel}
                onCountryChange={
                  isSwitchableCountry(linkDefaultCountry)
                    ? handleCountryChange
                    : undefined
                }
                supportedCountries={
                  isSwitchableCountry(linkDefaultCountry)
                    ? SUPPORTED_COUNTRIES
                    : []
                }
              />
            </div>
          </section>
          <section
            style={{
              background: 'white',
              paddingBlock: '20px',
              paddingInline: '20px',
              borderRadius: '10px',
            }}
          >
            <p
              style={{
                paddingTop: '20px',
                fontWeight: 700,
                fontFamily: 'Open Sans',
                fontSize: '20px',
                marginBottom: '32px',
                color: 'black',
              }}
            >
              Payment Details
            </p>
            {isLoadingCompleted && (
              <p
                style={{
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  color: '#4D4D4D',
                  marginBottom: '12px',
                }}
              >
                All prices displayed in {currency}
              </p>
            )}
            <section
              style={{display: 'flex', flexDirection: 'column', gap: '24px'}}
            >
              {!isLoadingCompleted ? (
                <SummarySpinner />
              ) : (
                <>
                  <KCPPaymentDetails
                    country={selectedCountry}
                    locationNames={locationNames}
                    cartDetailObj={cartDetailObj}
                    paymentDetailType="monthly"
                    currentScreen={'accountInfo'}
                  />
                  <KCPPaymentDetails
                    country={selectedCountry}
                    locationNames={locationNames}
                    paymentDetailType="today"
                    cartDetailObj={cartDetailObj}
                    currentScreen={'accountInfo'}
                    couponList={couponList}
                  />
                </>
              )}
            </section>
            <div className="d-flex justify-content-end my-4">
              <Button
                disabled={!isFormFilled}
                variant="primary"
                type="submit"
                className="ad-continue ad-schedule-action"
                onClick={handleSubmit(handleOrderDetailContinue)}
                name="continue"
                data-testid={'continue-button'}
              >
                Continue
              </Button>
            </div>
          </section>
        </section>
      ) : (
        <section
          style={{
            display: 'grid',
            gridTemplateColumns: '293fr 137fr',
            alignItems: 'stretch',
            width: '100%',
            gap: '26px',
            boxSizing: 'border-box',
            paddingInline: '24px',
          }}
        >
          {/* LEFT PANEL */}
          <section
            style={{
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              alignSelf: 'flex-start',
              maxHeight: 'calc(100vh - 108px)',
            }}
          >
            <img
              src={thryvPeek}
              alt=""
              style={{
                position: 'absolute',
                top: '0',
                transform: 'translateY(-80%)',
                right: '20px',
                zIndex: 1,
                pointerEvents: 'none',
                width: '141px',
              }}
            />
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                overflow: 'hidden',
                maxHeight: 'calc(100vh - 108px)',
              }}
            >
              {/* HEADER */}
              <div
                style={{
                  paddingInline: '20px',
                  paddingBlock: '20px',
                  flexShrink: 0,
                }}
              >
                <p className="payment-method-label" style={{fontSize: '18px'}}>
                  Account Information
                </p>
              </div>
              {/* SCROLLABLE FORM */}
              <div
                className="payment-form-scroll"
                style={{
                  flex: 1,
                  minHeight: 0,
                  overflowY: 'auto',
                  padding: '20px',
                  scrollbarGutter: 'stable',
                  background: '#DDE1EA',
                  borderRadius: '10px 10px 0px 0px',
                }}
              >
                <div
                  style={{
                    background: 'white',
                    borderRadius: '10px',
                    padding: '16px',
                  }}
                >
                  <AccountDetails
                    register={register}
                    errors={errors}
                    listOfStates={listOfStates}
                    validatedEmail={validatedEmail}
                    setValidatedEmail={setValidatedEmail}
                    email={email}
                    emailRegistered={emailRegistered}
                    setEmailRegistered={setEmailRegistered}
                    setAccountInformation={setAccountInformation}
                    setFormFilledStatus={setFormFilledStatus}
                    trigger={trigger}
                    control={control}
                    setValue={setValue}
                    state={state}
                    handleSubmit={handleSubmit}
                    selectedCountry={selectedCountry}
                    onSessionResume={setExistingThryvId}
                    stateLabel={stateLabel}
                    cityLabel={cityLabel}
                    postalLabel={postalLabel}
                    onCountryChange={
                      isSwitchableCountry(linkDefaultCountry)
                        ? handleCountryChange
                        : undefined
                    }
                    supportedCountries={
                      isSwitchableCountry(linkDefaultCountry)
                        ? SUPPORTED_COUNTRIES
                        : []
                    }
                  />
                </div>
              </div>
              {/* STICKY FOOTER */}
              <div
                style={{
                  paddingInline: '20px',
                  paddingTop: '10px',
                  paddingBottom: '14px',
                  backgroundColor: 'white',
                  flexShrink: 0,
                }}
              >
                <div className="d-flex justify-content-end">
                  <Button
                    disabled={!isFormFilled}
                    variant="primary"
                    type="submit"
                    className="ad-continue ad-schedule-action"
                    onClick={handleSubmit(handleOrderDetailContinue)}
                    name="continue"
                    data-testid={'continue-button'}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </section>

          {/* RIGHT PANEL */}
          <section
            style={{
              background: '#ffffff',
              borderRadius: '16px',
              height: 'calc(100vh - 108px)',
              maxHeight: 'calc(100vh - 108px)',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }}
          >
            {/* CURRENCY DISCLAIMER */}
            {isLoadingCompleted && (
              <p
                style={{
                  fontFamily: 'Open Sans',
                  fontSize: '12px',
                  color: '#4D4D4D',
                  margin: '0',
                  paddingInline: '20px',
                  paddingBlock: '10px',
                  flexShrink: 0,
                }}
              >
                All prices displayed in {currency}
              </p>
            )}
            {/* TABS HEADER */}
            <div style={{flexShrink: 0, paddingInline: '10px'}}>
              <GradientTabs
                activeTab={activeRightTab}
                onChange={setActiveRightTab}
                variant="payment"
              >
                <GradientTab id="today">
                  <div className="label">
                    <p
                      className={`tab-label-title${activeRightTab === 'today' ? ' active' : ''}`}
                    >
                      Due Today{' '}
                      <span>
                        (
                        {getCoreTabItemCount(cartDetailObj, 'today') ??
                          (cartDetailObj?.plans || []).filter(
                            p =>
                              ![
                                'addon-5-signatures_usage',
                                'app-websitebuilder',
                                'cc_basicpls-5-thryv-m2m',
                                'thryvprfee',
                              ].includes(p.code),
                          ).length}{' '}
                        Items)
                      </span>
                    </p>
                  </div>
                  <p
                    className={`tab-price${activeRightTab === 'today' ? ' active' : ''}`}
                  >
                    {(() => {
                      const t = computeTabTotal({
                        paymentDetailType: 'today',
                        cartDetailObj,
                        couponList,
                        country: selectedCountry,
                      })
                      return t != null
                        ? `${formatPrice({amount: t, country: selectedCountry})} + Tax`
                        : ''
                    })()}
                  </p>
                </GradientTab>
                <GradientTab id="monthly">
                  <div className="label blue">
                    <p
                      className={`tab-label-title${activeRightTab === 'monthly' ? ' active' : ''}`}
                    >
                      {(() => {
                        const annualT = computeTabTotal({
                          paymentDetailType: 'annual',
                          cartDetailObj,
                          country: selectedCountry,
                        })
                        const monthlyT = computeTabTotal({
                          paymentDetailType: 'monthly',
                          cartDetailObj,
                          country: selectedCountry,
                        })
                        return annualT > 0 && monthlyT === 0
                          ? 'Due Annually'
                          : 'Due Monthly'
                      })()}{' '}
                      <span>
                        (
                        {(() => {
                          const annualT = computeTabTotal({
                            paymentDetailType: 'annual',
                            cartDetailObj,
                            country: selectedCountry,
                          })
                          const monthlyT = computeTabTotal({
                            paymentDetailType: 'monthly',
                            cartDetailObj,
                            country: selectedCountry,
                          })
                          const isAnnualView = annualT > 0 && monthlyT === 0
                          const isAnnualItem = p =>
                            String(p.code || '')
                              .toLowerCase()
                              .includes('annual') ||
                            String(p.name || '')
                              .toLowerCase()
                              .includes('annual') ||
                            String(p.name || '')
                              .toLowerCase()
                              .includes('yearly')
                          const coreCount = getCoreTabItemCount(
                            cartDetailObj,
                            isAnnualView ? 'annual' : 'monthly',
                          )
                          if (coreCount !== null) return coreCount
                          return (cartDetailObj?.plans || []).filter(
                            p =>
                              ![
                                'addon-5-signatures_usage',
                                'app-websitebuilder',
                                'cc_basicpls-5-thryv-m2m',
                                'thryvprfee',
                              ].includes(p.code) &&
                              p.prodType !== 'OneTimeFees' &&
                              p.prodType !== 'oneTimeFee' &&
                              p.section !== 'oneTimeFees' &&
                              p.groupKey !== 'oneTimeFees' &&
                              (isAnnualView
                                ? isAnnualItem(p)
                                : !isAnnualItem(p)),
                          ).length
                        })()}{' '}
                        Items)
                      </span>
                    </p>
                  </div>
                  <p
                    className={`tab-price${activeRightTab === 'monthly' ? ' active' : ''}`}
                  >
                    {(() => {
                      const annualT = computeTabTotal({
                        paymentDetailType: 'annual',
                        cartDetailObj,
                        country: selectedCountry,
                      })
                      const monthlyT = computeTabTotal({
                        paymentDetailType: 'monthly',
                        cartDetailObj,
                        country: selectedCountry,
                      })
                      const t =
                        annualT > 0 && monthlyT === 0 ? annualT : monthlyT
                      return t != null
                        ? `${formatPrice({amount: t, country: selectedCountry})} + Tax`
                        : ''
                    })()}
                  </p>
                </GradientTab>
              </GradientTabs>
            </div>

            {/* SCROLLABLE PRODUCTS */}
            <div
              style={{
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              <div
                className="payment-form-scroll"
                style={{
                  position: 'absolute',
                  inset: 0,
                  overflowY: 'auto',
                  padding: '10px',
                  scrollbarGutter: 'stable',
                  background: '#DDE1EA',
                  borderRadius: '10px',
                  boxShadow: '0px 0px 22px 0px #00000040 inset',
                }}
              >
                {!isLoadingCompleted ? (
                  <SummarySpinner />
                ) : activeRightTab === 'today' ? (
                  <KCPPaymentDetails
                    country={selectedCountry}
                    locationNames={locationNames}
                    paymentDetailType="today"
                    cartDetailObj={cartDetailObj}
                    currentScreen={'accountInfo'}
                    couponList={couponList}
                    hideHeading
                  />
                ) : (
                  <KCPPaymentDetails
                    country={selectedCountry}
                    locationNames={locationNames}
                    cartDetailObj={cartDetailObj}
                    paymentDetailType="monthly"
                    currentScreen={'accountInfo'}
                    hideHeading
                  />
                )}
              </div>
            </div>
          </section>
        </section>
      )}
      {showComingSoonModal && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: '12px',
              padding: '40px 32px',
              maxWidth: '440px',
              width: '90%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              textAlign: 'center',
            }}
          >
            <p
              style={{
                fontFamily: 'Open Sans',
                fontWeight: 700,
                fontSize: '22px',
                margin: 0,
              }}
            >
              Coming Soon
            </p>
            <p
              style={{
                fontFamily: 'Open Sans',
                fontSize: '14px',
                color: '#4D4D4D',
                margin: 0,
              }}
            >
              This product is not yet available in your region. Please contact
              your representative for a new link.
            </p>
            <Button
              variant="primary"
              onClick={() => setShowComingSoonModal(false)}
              style={{marginTop: '8px', fontFamily: 'Open Sans'}}
            >
              Close
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
